<p-tag [severity]="severity">{{ label }}</p-tag>
